import { NuevaCompra } from "../../../services/comprasServicios";
import { MetodoPago } from "../../../services/ventasServicios";

export interface Model {
  idMascota: string;
  propietario: string;
  nombreMascota: string;
  detallesPorProducto: Map<string, DetalleProducto>;
  datosPago?: { metodo: MetodoPago; monto: number };
  total: number;
}

export interface DetalleProducto {
  cantidad: number;
  nombre: string;
  valor: number;
}

export const defaultModel: Model = {
  idMascota: "",
  propietario: "",
  nombreMascota: "",
  detallesPorProducto: new Map(),
  total: 0,
};

export const calcularTotalCompra = (detalles: DetalleProducto[]): number => {
  return detalles
    .map((d) => d.cantidad * d.valor)
    .reduce((prev, curr) => prev + curr);
};

export const buildNuevaCompra = ({
  idMascota,
  detallesPorProducto,
  datosPago,
}: Model): NuevaCompra => {
  return {
    idMascota,
    detalles: Array.from(detallesPorProducto.entries()).map((entry) => ({
      idProducto: entry[0],
      cantidad: entry[1].cantidad,
      valorFinal: entry[1].valor,
    })),
    datosPago,
  };
};
